import {Grid} from '@material-ui/core';
import {LockedIcon} from 'components/icons/icons';
import {CenteredContainer} from 'components/LoadingPage';
import {H4, P} from 'components/TypographyShortcuts';

const Unauthorized = ({
    message = 'You are unauthorized to access this page.',
}) => {
    return (
        <CenteredContainer direction='column'>
            <Grid item>
                <LockedIcon />
            </Grid>
            <Grid item>
                <H4 gutterBottom={false}>Unauthorized</H4>
            </Grid>
            <Grid item>
                <P>{message}</P>
            </Grid>
        </CenteredContainer>
    );
};

export default Unauthorized;
